export enum PasswordIconEnum {
  Hide = 'eye-outline',
  Show = 'eye-off-outline',
}
